import React from "react";
import { InfoIconCard } from "../NotFound/NotFound";
import { Button } from "react-bootstrap";
import { _t } from "app/i18n/i18n";
import { FaIcon } from "lib/FaIcon";
import { BASENAME } from "lib/routing";

export const SessionExpired = () => (
  <InfoIconCard
    title="Unauthorised"
    icon="fa fa-user-clock fa-4x my-4"
    body={
      <div>
        Access to this resource has not been authorised or your session has expired.
        <br />
        <br />
        Please click below to visit the home page or contact support.
      </div>
    }
    footer={<HomeButton />}
  />
);

const HomeButton = () => (
  <a href={BASENAME} className="d-block text-center">
    <Button>
      {_t("To Home Page")}
      <FaIcon icon="fas fa-home ml-2" align="top" />
    </Button>
  </a>
);
